<template>
    <v-container>
        <v-alert
        :value="true"
        type="warning"
        >Nos econtramos bajo mantenimiento. Vuelva a intentarlo más tarde.</v-alert>
    </v-container>
</template>
<script>

export default {
    name: 'UpdateFailView',
    data () {
      return {     
        timeout: null,
      }
    },
    mounted(){
        var thisaux = this;
        
        this.timeout = setTimeout(function(){
            if (thisaux.$route.name == 'updateFail'){
                window.location.reload(true);
            }
        },60000)
    },
    components:{
        
    },
    computed:{
        
    }
}
</script>
